import editIcon from "../../images/edit-icon.svg";
import { BsToggleOn, BsToggleOff } from "react-icons/bs";

const AllergensTable = ({ data = [], onToggleStatus, onEdit }) => {
  return (
    <div className="border rounded-md h-full min-h-0 overflow-hidden">
      <div className="h-full overflow-y-auto table-scroll">
        <table className="w-full table-fixed">
          <thead className="bg-light sticky top-0 z-10 border-b border-gray-200">
            <tr>
              <th className="w-[110px] px-3 py-2 text-left text-primary text-sm">
                ID
              </th>
              <th className="w-[200px] px-3 py-2 text-left text-primary text-sm">
                Name
              </th>
              <th className="px-3 py-2 text-left text-primary text-sm">
                Description
              </th>
              <th className="w-[100px] px-3 py-2 text-left text-primary text-sm">
                Status
              </th>
              <th className="w-[110px] px-3 py-2 text-left text-primary text-sm">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan={5}
                  className="h-[240px] text-center text-sm text-gray-500"
                >
                  No allergens found
                </td>
              </tr>
            ) : (
              data.map((row) => (
                <tr key={row.ID} className="border-b h-12">
                  <td className="px-3 py-2 text-sm">{row.Code}</td>

                  <td className="px-3 py-2 text-sm">
                    <div className="multi-line-ellipsis" title={row.Name}>
                      {row.Name}
                    </div>
                  </td>

                  <td className="px-3 py-2 text-sm text-gray-500">
                    <div
                      className="multi-line-ellipsis"
                      title={row.Description}
                    >
                      {row.Description || "-"}
                    </div>
                  </td>

                  <td className="px-3 py-2 text-sm">
                    {row.StatusCodeId === 1 || row.StatusCodeId === true
                      ? "Active"
                      : "Inactive"}
                  </td>

                  <td className="px-3 py-2">
                    <div className="flex items-center gap-3">
                      <img
                        src={editIcon}
                        alt="Edit"
                        title="Edit"
                        className="cursor-pointer"
                        onClick={() => onEdit(row)}
                      />

                      <button
                        onClick={() =>
                          onToggleStatus(row.ID, row.StatusCodeId)
                        }
                        className="cursor-pointer"
                        title={
                          row.StatusCodeId === 1 || row.StatusCodeId === true
                            ? "Deactivate Allergen"
                            : "Activate Allergen"
                        }
                      >
                        {row.StatusCodeId === 1 || row.StatusCodeId === true ? (
                          <BsToggleOn size={28} color="#163D68" />
                        ) : (
                          <BsToggleOff size={28} color="#9CA3AF" />
                        )}
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllergensTable;
